<template>
  <div class="similar-jobs-toggle">
    <v-btn
      variant="outlined"
      class="similar-jobs-button text-button-2 text-textLight"
      :active="currentTab === 'similarJobs'"
      @click="setCurrentTab('similarJobs')"
    >
      Similar Jobs
    </v-btn>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';

const rightPanelStore = useDocumentRightPanel();
const { currentTab } = storeToRefs(rightPanelStore);
const { setCurrentTab } = rightPanelStore;
</script>

<style lang="less" scoped>
.similar-jobs-button {
  border-color: @stroke-default;
}
</style>
